module.exports = __webpack_public_path__ + "img/home-TestMeeting2.bc69482b.png";